exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-demo-dipendenti-index-js": () => import("./../../../src/pages/demo-dipendenti/index.js" /* webpackChunkName: "component---src-pages-demo-dipendenti-index-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-preventivo-js": () => import("./../../../src/pages/preventivo.js" /* webpackChunkName: "component---src-pages-preventivo-js" */),
  "component---src-pages-thank-you-js": () => import("./../../../src/pages/thank-you.js" /* webpackChunkName: "component---src-pages-thank-you-js" */)
}

